/**
 * Since this compareFn handles undefined values, it priorities items that do have a value.
 */
export const compareFnByNumberAsc = <T>(
	selectAttribute: (item: T) => number | undefined | null,
	descending?: boolean,
) => {
	return (a: T, b: T) => {
		const valueA = selectAttribute(a);
		const valueB = selectAttribute(b);

		if (valueA === valueB) {
			return 0;
		}

		const isDescending = descending ? -1 : 1;

		if (typeof valueA !== 'number') {
			// this will arrange item A at the end of the list
			return 1 * isDescending;
		}

		if (typeof valueB !== 'number') {
			// this will arrange item B at the end of the list
			return -1 * isDescending;
		}

		return valueA > valueB ? 1 * isDescending : -1 * isDescending;
	};
};

export const compareFnByDate = <T>(selectAttribute: (item: T) => Date | undefined | null, descending?: boolean) => {
	return (a: T, b: T) => {
		const valueA = selectAttribute(a);
		const valueB = selectAttribute(b);

		if (valueA === valueB) {
			return 0;
		}

		const isDescending = descending ? -1 : 1;

		if (valueA === undefined || valueA === null) {
			// this will arrange item A at the end of the list
			return 1 * isDescending;
		}

		if (valueB === undefined || valueB === null) {
			// this will arrange item B at the end of the list
			return -1 * isDescending;
		}

		return valueA > valueB ? 1 * isDescending : -1 * isDescending;
	};
};
